import apiClient from "../../authentication/utils/core/axios";

/**
 * UserProfileAPI — COMMENT pattern
 * Handles profile, password, and session management
 */
const UserProfileAPI = {
  /**
   * Get the current user's profile
   */
  fetch: async () => {
    const response = await apiClient.get('/users/me');
    if (response.status !== 200) throw new Error('Failed to fetch user profile');
    return response.data;
  },

  /**
   * Update the current user's profile
   * @param {Object} userData
   */
  update: async (userData) => {
    const response = await apiClient.put('/users/me/update', userData);
    if (response.status !== 200) throw new Error('Failed to update user profile');
    return response.data;
  },

  /**
   * Change the user's password
   * @param {Object} passwordData - Should contain currentPassword and newPassword
   */
  changePassword: async (passwordData) => {
    const payload = { 
      current_password: passwordData.currentPassword, 
      new_password: passwordData.newPassword 
    };
    const res = await apiClient.put('/users/me/password', payload);
    // backend returns 204 No Content on success
    if (![200, 204].includes(res.status)) throw new Error('Failed to change password');
    return true; // no body expected
  },

  /**
   * Logout the current user
   */
  logout: async () => {
    const res = await apiClient.post('/logout');
    if (![200, 204].includes(res.status)) throw new Error('Logout failed');
    return true;
  }
};

export default UserProfileAPI;